<template>
  <PageBreadcrumb
    :crumbs="[{
      label: 'Gestione Amministratori',
      link: '/amministratori'
    }, {
      label: form.uuid ? 'Modifica Amministratore' : 'Aggiungi nuova Amministratore'
    }]"
  />
  <form autocomplete="off">
    <InputText
      v-model="form.email"
      :disabled="form.uuid"
      :error-fields="errorFields"
      name="email"
      :submitted="submitted"
    >
      Email
    </InputText>

    <InputSelect
      v-model="form.role"
      :error-fields="errorFields"
      name="role"
      :options="roles"
      :submitted="submitted"
    >
      Ruolo
    </InputSelect>

    <SubmitButtons
      :create-and-back="createAndBack"
      :create-and-stay="createAndStay"
      :mode="form.uuid ? 'update' : 'create'"
      :pending="pending"
      :update-and-back="updateAndBack"
      :update-and-stay="updateAndStay"
    />
  </form>
</template>
    
<script setup>
import { reactive } from 'vue';

import InputSelect from '@/components/form/InputSelect.vue';
import InputText from '@/components/form/InputText.vue';
import SubmitButtons from '@/components/form/SubmitButtons.vue';
import PageBreadcrumb from '@/components/PageBreadcrumb.vue';
import useAxios from '@/composables/axios';
import useForm from '@/composables/form';

const props = defineProps({
  id: {
    required: false,
    type: String,
    default: null
  }
})

const axios = useAxios()

let form = reactive({ email: '', role: '' })

if (props.id) {
  const resp = await axios.get('/admin-user/' + props.id);
  form = reactive(resp.data)
}

const roles = [
  { label: 'Global Manager', id: 'global_manager' },
  { label: 'Auction Manager', id: 'auction_manager' },
  { label: 'Base Manager', id: 'base_manager' },
]

const rules = {
  email: {
    type: 'email',
    max: 255,
    required: true
  },
  role: {
    type: 'string',
    max: 255,
    required: true
  }
}
const { submitted, pending, errorFields, createAndBack, createAndStay, updateAndBack, updateAndStay } = useForm(form, 'admin-user', rules, {
  create: 'Amministratore creato con successo',
  update: 'Amministratore modificato con successo'
}, '/amministratori')

</script>
   
